<div  [hidden]="isLoading || (!grid || grid?.data?.length === 0)">
    <table id="relatorios" mat-table [dataSource]="grid" class="table-sm">
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td mat-cell *matCellDef="let grid" width="90px">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item color="primary" (click)="detalhesLote(grid)">
                        <mat-icon fontSet="fas" fontIcon="fa-eye"></mat-icon>
                        <span>Detalhes</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef>Usuário</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.usuario }}
            </td>
        </ng-container>

        <ng-container matColumnDef="clienteNome">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.cliente }}
            </td>
        </ng-container>

        <ng-container matColumnDef="lote">
            <th mat-header-cell *matHeaderCellDef>Lote</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.lote }}
            </td>
        </ng-container>

        <ng-container matColumnDef="qtdCte">
            <th mat-header-cell *matHeaderCellDef>Qtd. CT-e</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.qtdCte }}
            </td>
        </ng-container>

        <ng-container matColumnDef="qtdeNrt">
            <th mat-header-cell *matHeaderCellDef>Qtd. NRT</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.qtdNrt }}
            </td>
        </ng-container>

        <ng-container matColumnDef="qtdNF">
            <th mat-header-cell *matHeaderCellDef>Qtd. NF</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.qtdNf }}
            </td>
        </ng-container>

        <ng-container matColumnDef="totalFrete">
            <th mat-header-cell *matHeaderCellDef>Total Frete</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.totalFrete | currency: 'BRL' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="dataInclusao">
            <th mat-header-cell *matHeaderCellDef>Data Inclusão</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.dataInclusao | date:'dd/MM/yyyy hh:mm'}}
            </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td mat-cell *matCellDef="let grid">
                {{ grid.acao }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let grid" [ngClass]="getClass(grid.statusDescricao)">
                {{grid.statusDescricao}}
            </td>
        </ng-container>

        <ng-container matColumnDef="concluido">
            <th mat-header-cell *matHeaderCellDef>Concluido</th>
            <td mat-cell *matCellDef="let grid" [ngClass]="getClass(grid.statusDescricao)">
                {{ grid.percentualConclusao | percent }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
<app-paginacao [hidden]="isLoading || !grid || grid?.data?.length === 0" [pageIndex]="paging?.index"
    [pageSize]="paging?.size" [length]="paging?.length" (page)="parent.onPageChange($event)"
    [pageSizeOptions]="[10, 20, 50]">
</app-paginacao>
<div class="align-footer" [hidden]="isLoading || !grid || grid?.data?.length === 0">
    <button mat-stroked-button type="button" (click)="parent.excel()" [disabled]="isLoadingDownload">
        <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
            <mat-spinner diameter="20" color="dark"></mat-spinner>
            &nbsp; Baixando
        </span>
        <span *ngIf="!isLoadingDownload">
            <i class="fas fa-file-excel"></i> Download Excel
        </span>
    </button>
</div>

<div *ngIf="!isLoading && grid?.data?.length === 0" class="d-flex justify-content-center align-items-center"
    style="height: 100px">
    {{exibirGrid ? 'Nenhum registro encontrado!' :''}}
</div>
